<div class="farol">
  @if (noShow) {
    <div class="farol-noshow-tag" [matTooltip]="noShow.detalhe || ''">No-show</div>
  }

  <div class="farol-dots">
    @for (fase of farol.fases; track fase.numero; let last = $last) {
      <button
        type="button"
        class="farol-dot"
        [ngClass]="'farol-dot--' + corDaFase(fase)"
        [matTooltip]="fase.nome + (registradoPor(fase) ? ' · ' + registradoPor(fase) : '')"
        (click)="onClickFase(fase)"
      >
        @if (corDaFase(fase) === 'confirmada') {
          <mat-icon class="farol-dot-icon">check</mat-icon>
        } @else {
          {{ fase.numero }}
        }
      </button>
      @if (!last) {
        <div class="farol-connector" [ngClass]="corDaFase(fase) === 'confirmada' ? 'farol-connector--ok' : ''"></div>
      }
    }
  </div>

  <div class="farol-labels">
    @for (fase of farol.fases; track fase.numero) {
      <span class="farol-label">{{ abreviacao(fase) }}</span>
    }
  </div>

  @for (fase of farol.fases; track fase.numero) {
    @if (legendaTempo(fase)) {
      <div class="farol-legenda" [ngClass]="'farol-legenda--' + corDaFase(fase)">{{ legendaTempo(fase) }}</div>
    }
  }

  @if (mostrarConfirmarEnvio()) {
    <button
      type="button"
      class="farol-cta-envio"
      matTooltip="A fase 1 está cobrando confirmação, mas ninguém registrou que mandou a OS pro motorista. O sistema não envia sozinho — isto só registra que você mandou."
      (click)="onConfirmarEnvio()"
    >
      Confirmar envio
    </button>
  } @else if (envio) {
    <div class="farol-envio-info" [matTooltip]="'Confirmado por ' + envio.por">{{ envioResumo() }}</div>
  }
</div>
